import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-select-readonly',
  templateUrl: './select-readonly.component.html',
  styleUrls: ['./select-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectReadonlyComponent {}
